import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { useSiteContext } from "../hooks/use-site-context"

import Layout from "../components/layout"
import Seo from "../components/seo"
import ZodiacSelection from "../components/ZodiacSelection"
import ZodiacSelectionFB from "../components/ZodiacSelectionFB"
import Welcome from "../components/Welcome"
import Subtitles from "../components/Subtitles"
import EnterFirstName from "../components/EnterFirstName"
import FirstLetter from "../components/FirstLetter"
import AstrologyReading from "../components/AstrologyReading"
import ShowFirstName from "../components/ShowFirstName"
import EnterLastAndEmail from "../components/EnterLastAndEmail"
import AstralVibrationNumber from "../components/AstralVibrationNumber"
import AstralNumberReading from "../components/AstralNumberReading"
import CloseTheSale from "../components/CloseTheSale"

// import backgroundSrc from "../data/backgroundSrc.json"

const IndexPage = () => {
  const { currentStep, setCurrentStep, setSelectedSign, setCurrentAudioStage } =
    useSiteContext()

  const isBrowser = typeof window !== "undefined"

  React.useEffect(() => {
    if (isBrowser && window.location.search.includes("affiliate=astroveo")) {
      const script = document.createElement("script")
      script.src =
        "https://tip.toptrackpro.com/click?key=d29301a6916ec9cb1385&lp_type=pixel"
      script.async = true

      document.head.appendChild(script)
    }

    if (isBrowser) {
      // 1. Set the window.clickbank config
      const configScript = document.createElement("script")
      configScript.innerHTML = `
      window.clickbank = {
        vendor: "truthstars"
      };
    `
      document.head.appendChild(configScript)

      // 2. Load the ClickBank hop.min.js script
      const cbScript = document.createElement("script")
      cbScript.src = "https://scripts.clickbank.net/hop.min.js"
      cbScript.defer = true
      document.head.appendChild(cbScript)
    }
  }, [])

  return (
    <Layout>
      <div
        className={`relative flex flex-col items-center min-h-screen pb-[170px]`}
      >
        <div className="absolute top-0 left-0 w-full h-full transition starryBg animate-hue" />
        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-30" />
        <div
          className={`w-full z-40 ${
            currentStep === 10 ? "max-w-3xl" : "max-w-xl"
          } px-6 mt-6`}
        >
          {currentStep === 1 && <ZodiacSelection />}
          {currentStep === 2 && <Welcome />}
          {currentStep === 3 && <EnterFirstName />}
          {currentStep === 4 && <FirstLetter />}
          {currentStep === 5 && <AstrologyReading />}
          {currentStep === 6 && <ShowFirstName />}
          {currentStep === 7 && <EnterLastAndEmail />}
          {currentStep === 8 && <AstralVibrationNumber />}
          {currentStep === 9 && <AstralNumberReading />}
          {currentStep === 10 && <CloseTheSale />}
        </div>
        {currentStep > 1 && <Subtitles />}
      </div>
    </Layout>
  )
}

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => <Seo title="Select Your Zodiac Sign" />

export default IndexPage
